/* eslint-disable */
// @ts-nocheck

import { ReactNode } from 'react'

import { Document, Page } from '@react-pdf/renderer'

interface DocumentPageInterface {
  children: ReactNode
  orientation?: any | undefined
}

const DocumentPage = ({ children, orientation }: DocumentPageInterface) => {
  return (
    <Document>
      <Page
        orientation={orientation ? orientation : 'portrait'}
        style={{ paddingTop: 50, paddingBottom: 20, paddingHorizontal: 20 }}
        wrap
      >
        {children}
      </Page>
    </Document>
  )
}

export default DocumentPage
